class StorageClassSwitchController {
  /* @ngInject */
  constructor() {
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value) {
    this.onChange(this.name, value);
  }
}

export default StorageClassSwitchController;
